









import {Vue, Component} from 'vue-property-decorator';
import IconCloseButton from '@/components/buttons/IconCloseButton.vue';

@Component({
  components: {
    IconCloseButton,
  },
})
export default class ChatHeader extends Vue {}
